import { render, staticRenderFns } from "./QutaEditAbout.vue?vue&type=template&id=1a32359a&scoped=true&"
import script from "./QutaEditAbout.vue?vue&type=script&lang=js&"
export * from "./QutaEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32359a",
  null
  
)

export default component.exports